module.exports = __webpack_public_path__ + "img/sharedMediaWithSpaceStorageMedias.9d1ec5eb.svg";